
<template>
  <div>
  <section class="banners">
    <!-- <div class="swiper-banner swiper-container swiper-no-swiping">
      <div class="carousel-body swiper-wrapper">
        <div v-for="(item, index) in bannerArr" :key="index" class="swiper-slide carousel-box">
          <img :src="'storage/'+item.imgurl" :alt="item.title" draggable="false" />
        </div>
      </div>
    </div> -->
      <img
        src="../assets/img/flow/broadcast_banner.png"
        alt="直播带货"
      />
  </section>
  <div class="fixed-div">
    <div class="main-div" @mouseover = "showSt = true">
      <img src="../assets/img/flow/fixed/float.png" alt="" @mouseout = "showSt = false">
    </div>
    <div class="content-wrap" :class="showSt ? 'showSt' : '' " @mouseover = "showSt = true" @mouseout = "showSt = false">
      <div class="par-wrap" @click="toContact">
        <img src="../assets/img/flow/fixed/phone_icon.png" alt="">
        <div class="par-desc">
          <h4>广告商务合作</h4>
          <p>联系邮件：</p>
          <p>ad@chinanola.com</p>
          <p>或留下信息我们联系您</p>
        </div>

      </div>
      <div class="weixin-wrap">
        <img src="../assets/img/flow/fixed/weixin.png" class="weixin" alt="">
        <div class="img-wrap">
          <img src="../assets/img/channel-wchat.jpg" alt="">
        </div>
      </div>
    </div>
  </div>
  <div class="container-no">
    <!-- 让信息“主动招人” -->
    <div class="container-wrap">
      <section class="h4-wrap">
        <h4>丰富资源位及热门形式</h4>
        <div class="bar-wrap">
          <div class="span-wrap">
            <span :class="activeIndex == 1 ? 'active' : '' " @click = " activeIndex = 1 ">直播电商</span>
            <span :class="activeIndex == 2 ? 'active' : '' " @click = " activeIndex = 2 ">短视频电商</span>
          </div>
        </div>
        <div class="content-wrap" v-show = "activeIndex == 1">
          <div class="left-img">
            <img src="../assets/img/flow/ziyuan1.png" alt="">
          </div>
          <div class="right-text">
            <h4>人群中高价值人群的发现</h4>
            <p>有专业运营团队、设计团队、主播团队、策划团队、场控支持等等，可以提供全方面的直播支持，火吖跟抖音畅玩MCN、交个朋友等多家MCN机构也有深度合作，一起助力抖音商家直播，为抖音直播生态严格把控。做好品牌在抖音的入驻。</p>
          </div>
        </div>
        <div class="content-wrap" v-show = "activeIndex == 2">
          <div class="left-img">
            <img src="../assets/img/flow/ziyuan2.gif" alt="">
          </div>
          <div class="right-text">
            <h4>从0到1快速入门直通车</h4>
            <p>在电商行业有丰富的经验，在各大行业包括：日用百货、服饰内衣、个护美妆、食品饮料、节点礼品和鞋靴等都有品牌和竞价电商合作案例，针对对接的客户，我们要求每日在对接群里反馈账户情况和接下来的工作安排，用专业铸造成就，服务赢得未来。</p>
          </div>
        </div>
      </section>
    </div>
    <div class="daihuo">
      <section class="h2-wrap">
        <h4>短视频电商如何带货</h4>
        <p>核心数据和丰富的产品矩阵，为您的生意保驾护航</p>
        <div class="wrap">
          <div class="nav-wrap">
            <div class="item" @click="activeImg = 0">
              <div class="img-wrap">
                <img src="../assets/img/flow/broadcast/video_icon1_2.png" alt="">
              </div>
              <p :class="activeImg == 0 ? 'active' : ''">选对商品</p>
            </div>
            <div class="item" @click="activeImg = 1">
              <div class="img-wrap">
                <img src="../assets/img/flow/broadcast/video_icon2_2.png" alt="">
              </div>
              <p :class="activeImg == 1 ? 'active' : ''">挖掘商品卖点</p>
            </div>
            <div class="item" @click="activeImg = 2">
              <div class="img-wrap">
                <img src="../assets/img/flow/broadcast/video_icon3_2.png" alt="">
              </div>
              <p :class="activeImg == 2 ? 'active' : ''">击穿痛点</p>
            </div>
            <div class="item" @click="activeImg = 3">
              <div class="img-wrap">
                <img src="../assets/img/flow/broadcast/video_icon4_2.png" alt="">
              </div>
              <p :class="activeImg == 3 ? 'active' : ''">快速成交</p>
            </div>
          </div>

        </div>

      </section>
      <div class="content-wrap" v-show="activeImg == 0">
        <div class="left-wrap">
          <img src="../assets/img/flow/broadcast/video_icon1_1.png" alt="">
        </div>
        <div class="right-wrap">
          <div class="img-wrap">
            <img src="../assets/img/flow/broadcast/video_icon1.png" alt="">
          </div>
          <div class="content">
            <h4>选对商品</h4>
            <p>符合平台调性</p>
            <span>选品是重中之重符合平台买家特征容易引发冲动消费（实用的、好看的、新奇的）</span>
          </div>
        </div>
      </div>
      <div class="content-wrap" v-show="activeImg == 1">
        <div class="left-wrap">
          <img src="../assets/img/flow/broadcast/video_icon2_1.png" alt="">
        </div>
        <div class="right-wrap">
          <div class="img-wrap">
            <img src="../assets/img/flow/broadcast/video_icon2.png" alt="">
          </div>
          <div class="content">
            <h4>挖掘商品卖点</h4>
            <p>使用场景、应用度、商品特点</p>
            <span>鲁班业务就是广告投放、即时成交，需要全方位展现卖点</span>
          </div>
        </div>
      </div>
      <div class="content-wrap" v-show="activeImg == 2">
        <div class="left-wrap">
          <img src="../assets/img/flow/broadcast/video_icon3_1.png" alt="">
        </div>
        <div class="right-wrap">
          <div class="img-wrap">
            <img src="../assets/img/flow/broadcast/video_icon3.png" alt="">
          </div>
          <div class="content">
            <h4>击穿痛点</h4>
            <p>解决问题引发购买需求</p>
            <span>视频强引导转化，促发冲动消费。输出符合抖音调性的创意视频，用视频引发需求（推荐给你喜欢的内容），抓住卖点，直打痛点，解决需求。</span>
          </div>
        </div>
      </div>
      <div class="content-wrap" v-show="activeImg == 3">
        <div class="left-wrap">
          <img src="../assets/img/flow/broadcast/video_icon4_1.png" alt="">
        </div>
        <div class="right-wrap">
          <div class="img-wrap">
            <img src="../assets/img/flow/broadcast/video_icon4.png" alt="">
          </div>
          <div class="content">
            <h4>快速成交</h4>
            <p>无压力下单</p>
            <span>字节强大的浏览算法，推荐内容不重复，商品无比价（打信息差）货到付款优势，买家轻松下单，信任门槛低</span>
          </div>
        </div>
      </div>
    </div>
    <section class="h3-wrap">
      <h4>丰富的营销产品矩阵<br />构筑达成每一个营销目标</h4>
      <p>全方位、多维度数据打通和深度整合，打造流量精细化运营的营销闭环</p>
      <div class="wrap">
        <div class="right-wrap">
          <div class="content-wrap">
            <div class="nav">
              <span :class="currIndex == 0 ? 'active-span' : ''" @click="currIndex = 0">代投</span>
              <span :class="currIndex == 1 ? 'active-span' : ''" @click="currIndex = 1">代播</span>
            </div>
            <div class="item-wrap" v-show="currIndex == 0">
              <div class="item">
                <div class="img-wrap">
                  <img src="../assets/img/flow/broadcast/yingxiao_icon1.png" alt="">
                </div>
                <div class="content">
                  <h6>专业专属团队</h6>
                  <div class="desc">
                    <p>专业专属团队分析搭建计划，实时跟进竞价计划。分析转换数据统计、优化竞价计划。</p>
                  </div>
                </div>
                <div class="hide-img">
                  <img src="../assets/img/flow/broadcast/live_icon1.png" alt="">
                  <p>专业专属团队</p>
                </div>
              </div>
              <div class="item">
                <div class="img-wrap">
                  <img src="../assets/img/flow/broadcast/yingxiao_icon2.png" alt="">
                </div>
                <div class="content">
                  <h6>整合复盘优化</h6>
                  <div class="desc">
                    <p>协助三方数据整合复盘优化抖音行业大类目进行对比优化ROI转化优化给出粉丝画像以及产品受众，提高货品组合质量。</p>
                    <!-- <p>分析转换数据统计、优化竞价计划。</p> -->
                  </div>
                </div>
                <div class="hide-img">
                  <img src="../assets/img/flow/broadcast/live_icon2.png" alt="">
                  <p>整合复盘优化</p>
                </div>
              </div>
              <div class="item">
                <div class="img-wrap">
                  <img src="../assets/img/flow/broadcast/yingxiao_icon3.png" alt="">
                </div>
                <div class="content">
                  <h6>品牌活动策划</h6>
                  <div class="desc">
                    <p>根据后台数据分析进行商品节奏调整建议在促销活动策划、品牌活动策划、节日活动策划、抖音官方活动策划等活动策划上给与配合。</p>
                    <!-- <p>分析转换数据统计、优化竞价计划。</p> -->
                  </div>
                </div>
                <div class="hide-img">
                  <img src="../assets/img/flow/broadcast/live_icon3.png" alt="">
                  <p>品牌活动策划</p>
                </div>
              </div>
            </div>
            <div class="item-wrap" v-show="currIndex == 1">
              <div class="item">
                <div class="img-wrap">
                  <img src="../assets/img/flow/broadcast/yingxiao_icon4.png" alt="">
                </div>
                <div class="content">
                  <h6>专属直播间</h6>
                  <div class="desc">
                    <p>提供专属直播间，承接全品类直播服务，打造线上专柜。优质直播环境，隔音专业材质。</p>
                  </div>
                </div>
                <div class="hide-img">
                  <img src="../assets/img/flow/broadcast/live_icon1.png" alt="">
                  <p>专属直播间</p>
                </div>
              </div>
              <div class="item">
                <div class="img-wrap">
                  <img src="../assets/img/flow/broadcast/yingxiao_icon5.png" alt="">
                </div>
                <div class="content">
                  <h6>分析搭建计划</h6>
                  <div class="desc">
                    <p>专属团队分析搭建计划，现场实时跟进竞价计划。</p>
                    <!-- <p>分析转换数据统计、优化竞价计划。</p> -->
                  </div>
                </div>
                <div class="hide-img">
                  <img src="../assets/img/flow/broadcast/live_icon2.png" alt="">
                  <p>分析搭建计划</p>
                </div>
              </div>
              <div class="item">
                <div class="img-wrap">
                  <img src="../assets/img/flow/broadcast/yingxiao_icon6.png" alt="">
                </div>
                <div class="content">
                  <h6>助理一站式服务</h6>
                  <div class="desc">
                    <p>品牌归属实操人员，三方数据整合复盘优化，拥有专属中控、运营、助理一站式服务</p>
                    <!-- <p>分析转换数据统计、优化竞价计划。</p> -->
                  </div>
                </div>
                <div class="hide-img">
                  <img src="../assets/img/flow/broadcast/live_icon3.png" alt="">
                  <p>助理一站式服务</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
  </div>
</template>

<script>
export default {
  name: "channel",
  data() {
    return {
      msg: "数字营销",
      pages:"10",
      bannerArr:null,
      showTop:false,
      activeIndex:1,
      showSt:false,
      currIndex:0,
      activeNo:0,
      activeImg:0
    };
  },
  created() {
    // let that = this;
    // this.$ajax
    //   .post("https://test-game-static.oss-cn-hangzhou.aliyuncs.com/web/web-jsondata.json")
    //   .then(function (res) {
    //     console.log( res );
    //     that.bannerArr = res.banners[0].imgurl;
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
  },
  methods:{
    toContact(){
      this.$router.push("/contact");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/css/global";
@import "../assets/css/function";
@import "../assets/css/fixed";
@import "../assets/css/base/_fonts";


.container-no {
  padding-top: 1rem;
  height: auto;
  section {
    > h4 {
      letter-spacing: 2px;
      font-size: 1.5rem;
      color: #535353;
      font-weight: 700;
      line-height: 1.8rem;
      text-align: center;
      margin-bottom: .5rem;
    }
    > p {
      letter-spacing: 1px;
      line-height: 1.6em;
      color: #535353;
      text-align: center;
      &:nth-last-of-type(1) {
        margin-bottom: 20px;
      }
    }
  }
}
// banner图
.banners {
  position: relative;
  width: 100%;
  .swiper-slide{
    >div{
      height: 100%;
    }
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    max-height: 390px;
  }

}


// 让信息“主动招人”

.daihuo{
  padding: 4rem 0;
  .h2-wrap{
    .nav-wrap{
      display: flex;
      justify-content: space-between;
      .item{
        width: 23%;
        .img-wrap{
          img{
            margin: 0 auto;
          }
        }
        p{
          text-align: center;
          font-weight: bolder;
          color: #535353;
          letter-spacing: 1px;
        }
        .active{
          color: #E3362B;
        }
      }
    }
  }
  .content-wrap{
    display: flex;
    margin-top: 2rem;
    .left-wrap{
      max-width: 50%;
      img{
        height: 100%;
      }
    }
    .right-wrap{
      position: relative;
      .img-wrap{
        height: 100%;
        overflow: hidden;
        img{
          height: 100%;
        }
      }
      .content{
        position: absolute;
        left: 5%;
        top: 7%;
        color: #fff;
        width: 90%;
        h4{
          font-size: 1.2rem;
          letter-spacing: 1px;
          margin-bottom: .2rem;
          color: #fff;
        }
        p{
          font-size: .8rem;
          font-weight: bold;
          letter-spacing: 1px;
        }
        span{
          display: block;
          margin-top: 1rem;
          font-size: .6rem;
          letter-spacing: 1px;

        }
      }
    }
  }
}

.h3-wrap{
  padding: 0 1rem;
  >.wrap{
    .right-wrap{
      .content-wrap{
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        padding: 20px 0;
        height: 100%;
        width: 100%;

        .nav{
          display: flex;
          justify-content: center;
          margin-bottom: 20px;
          span{
            font-size:  1rem;
            margin: 0 2rem;
            padding: 0 10px;
            color: #535353;
            display: block;
            font-weight: 700;
            line-height: 2em;
            cursor: pointer;
          }
          .active-span{
            color: #E3362B;
            border-bottom: 2px solid #E3362B;
          }
        }
        .item-wrap{

          .item{
            position: relative;
            margin-bottom: 1rem;
            &:hover{
              & > .content{
                display: flex;
              }
              & > .hide-img{
                display: none;
              }
            }
            .content{
              position: absolute;
              left: 0;
              top: 0;
              height: 100%;
              display: none;
              flex-direction: column;
              justify-content: center;
              padding: 0 10px;

              h6{
                font-size: 1rem;
                text-align: center;
                color: #fff;
                line-height: 2em;
                letter-spacing: 2px;
                &::after{
                  content: "";
                  height: 2px;
                  width: 35%;
                  display: block;
                  margin: 0 auto 10px;
                  background-color: #E3362B;
                }
              }
              p{
                font-size: .8rem;
                line-height: 1rem;
                color: #fff;
                width: 82%;
                letter-spacing: 2px;
                margin: 0 auto;
              }
            }
            .hide-img{
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              height: 100%;
              display: flex;
              flex-direction: column;
              z-index: 66;
              p{
                font-size: .8rem;
                text-align: center;
                color: #fff;
                line-height: 1rem;
              }
              img{
                width: 74px;
                height: 76px;
                margin: 34px auto 5px;

              }
            }
          }
        }
      }
    }
  }
}
.h4-wrap,.h3-wrap{
  padding: 0 15px;
}
.h4-wrap{

 >p{
   display: flex;
   justify-content: center;
   >span{
     display: block;
     padding: 5px 15px;

   }
 }
 .bar-wrap{
   display: flex;
   justify-content: center;
   margin-top: 20px;
   margin-bottom: 40px;
  .span-wrap{
    display: flex;
    margin: 0 auto;
    border: 1px solid #FCF3F4;
    border-radius:  .5rem;
    >span{
      font-size: .8rem;
      display: inline-block;
      padding: 10px 20px;
      cursor: pointer;
      border-radius: 0px .5rem .5rem 0px;
      // border: 1px solid #FCF3F4;
      color: #535353;
      font-weight: bold;
      &:nth-of-type(1){
        border-radius: .5rem 0 0 .5rem;
      }
    }
    .active{
      background-color: rgb(178,16,16);
      color: #fff;
    }

  }
 }

 .content-wrap{
   display: flex;
   flex-direction: column;
   justify-content: center;
   .left-img{
     margin: 0 auto;
   }
   .right-text{
     padding: 0 1rem;
     >h4{
       text-align: center;
       font-size: 1.3rem;
       line-height: 1.3rem;
       font-weight: 500;
       color: #535353;
       padding: 5% 0;
     }
     p{
      color: #535353;
     }
   }
 }
}



.success-demo{
  position: relative;
  padding-top: 50px;
  .cal-wrap{
    width: 95%;
    margin: 0 auto;
    .carousel-box{
      >div{
        display: flex;
        border: 1px solid rgb(245,245,245);
        box-shadow: 2px 9px 7px rgb(245,245,245);
        margin: 5px;
        border-radius: 10px;
        .content-wrap{
          padding: 20px 50px;
          position: relative;
          min-width: 550px;
          .content-hd{
            display: inline-block;
            padding-bottom: 8px;
            font-size: 16px;
            color: #535353;
            border-bottom: 3px solid rgb(178,16,16);
          }
          .title{
            color: #535353;
            letter-spacing: 2px;
            margin-top: 10%;
          }
          .desc{
            margin-top: 10%;
            font-size: px1.5rem(16);
            color: #999;
            p{
              width:80%;
              margin: 0 auto;
            }
          }
          .con-ft{
            margin-top: 25%;
            display: flex;
            justify-content: space-between;
            color: #999;
            font-size: px1.5rem(16);
            position: absolute;
            left: 10%;
            right: 10%;
            bottom: 10%;
            .le-con{
              display: flex;
              flex-direction: column;
              justify-content: space-between;
            }
            p{
              padding: 5px 0;
            }
            span{
            font-size: px1.5rem(26);
              color: rgb(178,16,16);
            }
          }
        }
      }
    }
  }
}

.par-wrap{
  .wrap{
    .active{
      color: rgb(178,16,16);
      border-bottom:1px solid rgb(178,16,16);
    }
    >.nav-bar{
      display: flex;
      justify-content: center;
      border-bottom: 1px solid rgb(245,245,245);
      margin-bottom: 50px;
      z-index: -1;
      >.nav-item{
        width: 10%;
      }
      span{
        font-size: px1.5rem(16);
        width: 100%;
        display: block;
        height: 50px;
        line-height: 50px;
        text-align: center;
        cursor: pointer;
      }
    }
    .item-wrap{
      width: 14.2%;
      display: inline-block;
      padding: 0 20px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/page/broadcast.vue